
const swiperCards = (el) => {
    const sliderClass = el.dataset.class;
    return new Swiper(`.${sliderClass} .slider_cards`, {
        speed: 400,
        spaceBetween: 30,
        slidesPerView: 1.5,
        loop: true,
        enabled: true,
        breakpoints: {
            550: {
                slidesPerView: 2.5
            },
            769: {
                enabled: false
            }
        }
    });
}
let flipBlocks = document.querySelectorAll('.flip_cards_swiper')
if(flipBlocks){
    if (window.innerWidth <= 768) {
        flipBlocks.forEach((slider) => {
            swiperCards(slider)
        });
    }
}
window.addEventListener('resize', ()=> {
    if (flipBlocks) {
        checkWindowWidth()
    }
})
function checkWindowWidth(){
   
    if (window.innerWidth <= 768) {
        flipBlocks.forEach((slider) => {
            swiperCards(slider)
        });
    } else {
        document.querySelectorAll('.flip_cards_swiper .slider_cards').forEach(el => {
          
        })
        // flipBlocks.forEach((slider) => {
        //     console.log(slider.querySelector('.slider_cards').swiper);
        // });
    }
}